__turbopack_context__.v({
  "block": "CodeText-module__vTIT1W__block",
  "bordered": "CodeText-module__vTIT1W__bordered",
  "inline": "CodeText-module__vTIT1W__inline",
});
